import { get, post } from "../config/$ajax.js";
import {editBusinessCard, editDmsBusinessCard} from "@api/commodity";
import Vue from 'vue'
import { getErpHost } from '@/utils/domainHelper.js';

const API_HOST = getErpHost();

export const getAjax = (url, data = {}, params = {}) => {
  return get(API_HOST + url, data, params);
};

const Message = Vue.prototype.$message;

// 获取网商费率
export function queryFeeRate(data={}) {
    return getAjax('/fms/myBank/open/queryFeeRate?payType=MY_BANK', data);
}



/**
 * 尝试自动建立合作关系
 */
export function tryAutoCreateDistributor(data = {}, params = {}) {
  return post(`/dms/tryAutoCreateDistributor`, data, {appJson: true, submitType: 'json', isNeedLoading: false, ...params});
}

/**
 * 获取我的分销商
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryDistributorPageList = (data = {}, params = {}) => {
  return get(`/dms/queryDistributorPageList`, data, params);
};

/**
 * 供销商修改分销商信息
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const updateDistributorInfo = (
  data = {},
  params = { submitType: "json" }
) => {
  return post(`/dms/updateDistributorInfo`, data, params);
};

/**
 * 获取供销商服务信息
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryDmsCompanyInfo = (data = {}, params = {}) => {
  return get(`/dms/queryDmsCompanyInfo`, data, params);
};
/**
 * 邀请分销商
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const supplierInviteDisUrl = (data = {}, params = {}) => {
  return get(`/short/pc/create/supplierInviteDisUrl`, data, params);
};


/**
 * 设置是否合作是否需要审核
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const isToExamine = (data = {}, params = { submitType: "json" }) => {
  return post(`/dms/saveOrUpdateConfig`, data, params);
};

/**
 * 获取业务员列表
 * @param {} data
 * @param {*} params
 * @returns
 */
export const toDistributionStaff = (data = {}, params = {}) => {
  return get(`/dms/toDistributionStaff`, data, params);
};

/**
 * 我的分销商合作状态操作
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const optCooperateState = (
  data = {},
  params = { submitType: "json" }
) => {
  return post(`/dms/optCooperateState`, data, params);
};

/**
 * 供分销关系绑定
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const editCompanyAnnouncement = (data = {}, params = { submitType: "json" }) => {
  return post(`/companyBusinessInfo/editCompanyAnnouncement`, data, params);
};

/**
 * 修改公告
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const relationBind = (data = {}, params = { submitType: "json" }) => {
  return post(`/dms/relationBind`, data, params);
};

// 加入采购车
export const purchaseCartAdd = (data = {}, params) => {
  return post(`/distribution/shop/purchase/cart/add`, data, {appJson: true, submitType: 'json', isNeedLoading: params.isNeedLoading})
};


/**
 * 分销商品导入:查询商品在系统的存在状态
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryItemsExistStatus = (
  data = {},
  params = { submitType: "json" }
) => {
  return post(`/dim/queryItemsExistStatus`, data, params);
};

/**
 * 分销商品导入:同步供销商端的商品,含导入商品和加入分销
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const importSupplierItem = (
  data = {},
  params = { submitType: "json" }
) => {
  return post(`/dim/importSupplierItem`, data, params);
};

// 
export const distributionItemTransformNormalItem = (
  data = {},
  params = { submitType: "json" }
) => {
  return post(`/dim/distributionItemTransformNormalItem`, data, params);
};

/**
 * 分销商品导入:查看同步任务结果
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const queryJobResult = (data = {}, params = { isNeedLoading: false}) => {
  return post(`/dim/queryJobResult`, data, params);
};

/**
 * 获取加入分销商品的结果
 * @param {*} data
 * @param {*} params
 * @returns
 */
 export const joinDistributorItemResult = (data = {}, params = { isNeedLoading: false}) => {
  return post(`/dim/joinDistributorItemResult`, data, params);
};

/**
 * 分销商品 批量/单个 删除
 * @param {*} data
 * @param {*} params
 * @returns
 */
 export const distributorRemove = (data = {}, params = { submitType: "json" }) => {
  return post(`/item/distributor/remove`, data, params);
};

/**
 * 分销商品 批量/单个 铺货
 * @param {*} data
 * @param {*} params
 * @returns
 */
 export const distributorPublish = (data = {}, url='/taskScheduling/storageTask') => {
  return post(url, data, {submitType: "json"});
};

/**
 * 分销商品 批量/单个 铺货(新批量铺货接口,支持加分销+铺货)
 * @param {*} data
 * @param {*} params
 * @returns
 */
export const batchDistributorPublish = (data = {}, url) => {
    url = url || '/api/ocean/call/batch/publish/item'
    return post(url, data, {submitType: "json"});
  };
  
/**
 * 分销商品 编辑
 * @param {*} data
 * @param {*} params
 * @returns
 */
 export const detailByBaseItemId = (data = {}, params = { submitType: "json" }) => {
  return get(`/item/base/detailByBaseItemId`, data, params);
};

/**
 * 查询sku维度的商品列表
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
export const querySkuList = (data = {}, params = { submitType: 'json' }) => {
  return post('/item/base/findSkuList', data, params)
}

/**
 * 供销商-展架商品列表
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
 export const displayGoodsList = (data = {}, params = { submitType: 'json' }) => {
  return post('/supplierGoods/displayGoodsList', data, params)
}

/**
 * 分销商品列表
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
 export const itemDistributorPage = (data = {}, params = { submitType: 'json' }) => {
  return post('/item/distributor/page', data, params)
}
/**
 * 分销商品列表-sku维度
 */
 export const itemDistributorPageSku = (data = {}, params = { submitType: 'json' }) => {
  return post('/item/distributor/pageSku', data, params)
}

/**
 * 查询spu维度的商品列表
 */
export const querySpuList = function(data) {
  return post('/supplierGoods/distributionGoodsList', data, {appJson: true, submitType: 'json'})
}

/**
 * 供销商推广小店 - 供销商商品列表
 */
export const supplierPromotionShopItemList = function(data) {
  return post('/dms/supplierPromotionShopItemList', data, {appJson: true, submitType: 'json'})
}

/**
 * 转分销 - 供销商商品列表
 */
export const tradeChangeSupplierPromotionShopItemList = function(data) {
  return post('/trade/change/dms/supplierPromotionShopItemList', {...data, ifReturenParamSku: true}, {appJson: true, submitType: 'json'})
}

/**
 * 供销商推广小店 - 供销商商品列表
 */
 export const sharePromotionShopItemList = function(data) {
  return post('/share/supplierPromotionShopItemList', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}

/*
 * 供销商概览加名片
 * @param data
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const supplierPromotionShopCompanyInfo = (data = {}, params = { submitType: "json" }) => {
    return get('/dms/supplierPromotionShopCompanyInfo', data, params);
};


export const getKdzsShareUrl = (data) => {
  return get('/openapi/distribution/item/getKdzsShareUrl', data);
}

/**
 * 邀请逸淘分销商
 */
export const getYtShareUrl = (data) => {
  return get('/openapi/distribution/item/getInvitationShareUrl.json?businessType=YT_SHARE_URL', data);
}

/**
 * 供销商推广小店 - 获取供分销公司关系
 */
export const getCooperationRelation = function(data) {
  return get('/dms/getCooperationRelation', data, {appJson: true, submitType: 'json'})
}


/**
 * 分销商邀请供销商 - 分销商公司信息(我的分销名片展示)
 * @param data
 * @param params
 * @returns {Promise | Promise<unknown>}
 */
export const distributorInviteCompanyInfo = (data = {}, params = { submitType: "json" }) => {
    return get('/dms/distributorInviteCompanyInfo', data, params);
};



/**
 * 小程序二维码
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const generateQrCodeUrl = function(data) {
    return post('/qr/generateQrCodeUrl', data,
        {
            appJson: true,
            submitType: 'json',
        }
    )
}

/**
 * 小程序Schema码
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const generateMiniSchema = function(data) {
  return post('/qr/generateScheme', data,
    {
      appJson: true,
      submitType: 'json',
    }
  )
}


// 名片编辑
export function getEditDmsBusinessCard(data) {
    return editDmsBusinessCard(data).then(res => {
        if(res.result === 1) {
            return true
        }
        return false
    })
}

// 批量加入分销商商品
 export const joinDistributorItem = function(data) {
  return post('/dim/joinDistributorItem', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}

// 批量加入分销商商品
export const updateDistributorTyped = function(data) {
  return post('/cooperationManage/updateDistributorTyped', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}

// 商品供分销关系透出-分页查询
export const KmtfxItemManagePage = function(data) {
  return post('/kmtfx/item/manage/page', data, {appJson: true, submitType: 'json', isNeedLoading: true})
}
// 商品供分销关系透出-详情
export const KmtfxItemManageDetail = function(data) {
  return get('/kmtfx/item/manage/detail', data, {appJson: true, submitType: 'json', isNeedLoading: false})
}
// 商品供分销关系透出-解绑
export const KmtfxItemManageCancelFxItem = function(data) {
  return post(`/kmtfx/item/manage/cancelFxItem`, data, {appJson: true, submitType: 'json'})
}
// 商品供分销关系透出-批量解绑
export const submitBatchCancelFxItem = function(data) {
  return post(`/kmtfx/item/manage/submit/batchCancelFxItem`, data, {appJson: true, submitType: 'json'})
}
// 商品供分销关系透出-换绑
export const KmtfxItemManageCoverBindKmtFxItem= function(data)  {
  return post(`/kmtfx/item/manage/coverBindKmtFxItem`, data, {appJson: true, submitType: 'json'})
}
// 商品供分销关系透出-绑定供销商
export const KmtfxItemManageCoverItemBindSupplier= function(data) {
  return post(`/kmtfx/item/manage/itemBindSupplier`, data, {appJson: true, submitType: 'json'})
}
// 商品供分销关系透出-查询日志
export const KmtfxItemManageSearchLogPage= function(data) {
  return post(`/kmtfx/item/manage/searchLogPage`, data, {appJson: true, submitType: 'json'})
}
// 全量导入供销商分销商品
export const syncSupplierGoogs = function(data) {
  return post('/dim/importAllSupplierItem', data, {appJson: true, submitType: 'json', isNeedLoading: true});
}


// 采购车列表
export const purchaseGet = (data = {}, params = {submitType: 'json' }) => {
  return post(`/distribution/shop/purchase/cart/get`, data, params);
};
// 采购车内所有的供销商
export const purchaseSupplierList = (data) => {
  return get(`/distribution/shop/purchase/cart/getCartSupplierCompanyList`, data);
};
// 采购车内每个供销商下面的所有款
export const purchaseSupplierItemList = (data, params = {submitType: 'json' }) => {
  return post(`/distribution/shop/purchase/cart/getCartItem`, data, params);
};
// 每个款下面的所有sku
export const purchaseItemSkuList = (data, params={isNeedLoading}) => {
  return post(`/distribution/shop/purchase/cart/getCartSku`, data, {submitType: 'json', isNeedLoading:params.isNeedLoading});
};
// 批量设置数量
export const updCartItem = (data) => {
  return post(`/distribution/shop/purchase/cart/updCartItem`, data, {submitType: 'json', isNeedLoading: true});
};
// 删除款
export const kuanRemove = (data) => {
  return get(`/distribution/shop/purchase/cart/remove`, data);
};
// 删除sku
export const skuRemove = (data) => {
  return get(`/distribution/shop/purchase/cart/removeSku`, data);
};
// 修改sku
export const updSkuV2 = (data) => {
  return post(`/distribution/shop/purchase/cart/updSkuV2`, data, {submitType: 'json', isNeedLoading: true});
};


// 下单获取最近收货地址
export const receiptInfo = function(data) {
  return get('/pc/wx/retail/order/last/receiptInfo', data);
}
// 自动识别
export const recipientInfo = function(data) {
  return post('/pc/wx/retail/order/analysis/recipientInfo', data, {submitType: 'json', isNeedLoading: true});
}
// 获取运费
export const getPostFee = function(data) {
  return post('/pc/wx/retail/order/postFee', data, {submitType: 'json', isNeedLoading: true});
}
// 现场自提手机号
export const queryPhone = function(data) {
  return get('/pc/wx/retail/order/queryPhone', data);
}
// 现场自提收件人信息
export const queryDistributorReceiverInfo = function(data) {
  return post('/pc/wx/retail/order/queryDistributorReceiverInfo', data, { submitType: 'json' });
}
// 创建分销订单
export const createOrder = function(data) {
  return post('/pc/wx/retail/order/createFenxiaoOrder', data, {submitType: 'json', isNeedLoading: true, isNeedFailNotice: true});
}
// 获取财务账号列表
export const getPaymentAccountList = function(data) {
  return get('/pc/fms/account/getPaymentAccountList', data);
}
// 获取分销价
export const queryDistributorPrice = function(data) {
  return post('/pc/wx/retail/order/queryDistributorPrice', data, {submitType: 'json', isNeedLoading: false});
}
// 在线充值-获取payurl
export const payOnline = function(data, params = {submitType: 'json', isNeedLoading: true}) {
  return post('/pc/dms/addPayInfo', data, {...params, submitType: 'json'});
}
// 在线充值-获取payurl
export const payStatus = function(data) {
  return get('/pc/fms/accountPayment/detail', data);
}

// 查询收货地址
export const queryAddress = function(data) {
  return get('/pc/wx/address/queryAddress', data);
}
// 删除收货地址
export const deleteAddress = function(data) {
  return get('/pc/wx/address/deleteAddress', data);
}
// 设置默认，修改收货地址
export const saveOrUpdate = function(data) {
  return post('/pc/wx/address/saveOrUpdate', data, {submitType: 'json', isNeedLoading: true});
}

export const getTotalSkuExtApi = function(data) {
  return get('/item/distributor/totalSkuExt', data,{submitType: 'json', isNeedLoading: true});
}
export const syncSupplierSpecApi = function(data) {
  return post('/item/distributor/syncSupplierSpec', data,{submitType: 'json', isNeedLoading: true});
}
// 标记成我已处理
export const markMainImagesChangeApi = function(data) {
  return post('/item/distributor/markMainImagesChange', data, {submitType: 'json', isNeedLoading: true});
}
// 批量更新商品主图
export const batchUpdateMainImagesApi = function(data) {
  return post('/item/distributor/batchUpdateMainImages', data, {submitType: 'json', isNeedLoading: true});
}
// 分销商品sku详情
export const skuInfoListApi = function(data) {
  return post('/item/distributor/skuInfoList', data, {submitType: 'json', isNeedLoading: true});
}
// 批量更新店铺商品主图
export const batchEditItemPicApi = function(data) {
  return post('/item/edit/batchEditItemPic', data, {submitType: 'json',isNeedLoading: true});
}
// 批量更新店铺商品主图
export const queryScmJobResultApi = function(data) {
  return get('/item/edit/queryScmJobResult', data, {submitType: 'json',isNeedLoading: false});
}

/**
 * 供销关系-表格导入绑定
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
export const importFxItemBindApi = (data = {}, params = { isNeedLoading: true }) => {
    return post('/kmtfx/item/manage/importFxItemBind', data, { submitType: 'form-data', headers: { 'Content-Type': 'multipart/form-data' }, ...params });
};

// 查询导入任务进度
export const getSyncItemCountApi = function(data) {
  return get('/kmtfx/item/manage/queryImportFxItemBindResult', data, { isNeedLoading: false });
}

/**
 * 供销关系-下载失败信息excel接口
 * @param {*} data 
 * @param {*} params 
 * @returns 
 */
export const downloadFailTemplateApi = function(data) {
  return get('/kmtfx/item/manage/downloadFailTemplate', data, { isNeedLoading: false, responseType: 'blob', isNeedFailNotice: true });
}
